import { render, staticRenderFns } from "./AboutUsPageForm.vue?vue&type=template&id=800e1334&"
import script from "./AboutUsPageForm.vue?vue&type=script&lang=js&"
export * from "./AboutUsPageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports